import {
AlertOutlined,
ApartmentOutlined,
AppstoreAddOutlined,
AppstoreOutlined,
BankOutlined,
BarChartOutlined,
BellOutlined,
BgColorsOutlined,
BranchesOutlined,
CalendarOutlined,
CheckCircleOutlined,
ClockCircleOutlined,
CloseCircleOutlined,
CreditCardOutlined,
DashboardOutlined,
DatabaseOutlined,
DeleteOutlined,
DesktopOutlined,
DollarCircleOutlined,
DollarOutlined,
ExportOutlined,
FileDoneOutlined,
FileProtectOutlined,
FileTextOutlined,
FlagOutlined,
FontSizeOutlined,
GlobalOutlined,
GiftOutlined,
HistoryOutlined,
HomeOutlined,
IdcardOutlined,
InboxOutlined,
KeyOutlined,
LayoutOutlined,
LinkOutlined,
MailOutlined,
MergeCellsOutlined,
MessageOutlined,
MobileOutlined,
PauseCircleOutlined,
PercentageOutlined,
FunnelPlotOutlined,
QuestionCircleOutlined,
ReconciliationOutlined,
SafetyCertificateOutlined,
ScheduleOutlined,
SettingOutlined,
ShopOutlined,
ShoppingOutlined,
StopOutlined,
SwapOutlined,
TagsOutlined,
TeamOutlined,
ThunderboltOutlined,
ToolOutlined,
UserOutlined,
WalletOutlined
} from "@ant-design/icons";
import type { ReactNode } from "react";

/**
 * Zentrale Icon-Map für NavCardGrid (Einstellungen, Admin, Kommunikation, Sales, Finanzen).
 * Wird verwendet, wenn ein Item nur iconKey statt icon (ReactNode) angibt.
 */
export const navCardIconByKey: Record<string, ReactNode> = {
  AlertOutlined: <AlertOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  AppstoreAddOutlined: <AppstoreAddOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  BankOutlined: <BankOutlined />,
  BarChartOutlined: <BarChartOutlined />,
  BellOutlined: <BellOutlined />,
  BgColorsOutlined: <BgColorsOutlined />,
  BranchesOutlined: <BranchesOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  CheckCircleOutlined: <CheckCircleOutlined />,
  CloseCircleOutlined: <CloseCircleOutlined />,
  CreditCardOutlined: <CreditCardOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  DatabaseOutlined: <DatabaseOutlined />,
  DeleteOutlined: <DeleteOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  DollarCircleOutlined: <DollarCircleOutlined />,
  DollarOutlined: <DollarOutlined />,
  ExportOutlined: <ExportOutlined />,
  FileDoneOutlined: <FileDoneOutlined />,
  FileProtectOutlined: <FileProtectOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  FlagOutlined: <FlagOutlined />,
  FontSizeOutlined: <FontSizeOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  GiftOutlined: <GiftOutlined />,
  HistoryOutlined: <HistoryOutlined />,
  HomeOutlined: <HomeOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  InboxOutlined: <InboxOutlined />,
  KeyOutlined: <KeyOutlined />,
  LayoutOutlined: <LayoutOutlined />,
  LinkOutlined: <LinkOutlined />,
  MailOutlined: <MailOutlined />,
  MergeCellsOutlined: <MergeCellsOutlined />,
  MessageOutlined: <MessageOutlined />,
  MobileOutlined: <MobileOutlined />,
  PauseCircleOutlined: <PauseCircleOutlined />,
  PercentageOutlined: <PercentageOutlined />,
  FunnelPlotOutlined: <FunnelPlotOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  ReconciliationOutlined: <ReconciliationOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  ScheduleOutlined: <ScheduleOutlined />,
  SettingOutlined: <SettingOutlined />,
  ShopOutlined: <ShopOutlined />,
  ShoppingOutlined: <ShoppingOutlined />,
  StopOutlined: <StopOutlined />,
  SwapOutlined: <SwapOutlined />,
  TagsOutlined: <TagsOutlined />,
  TeamOutlined: <TeamOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  ToolOutlined: <ToolOutlined />,
  UserOutlined: <UserOutlined />,
  WalletOutlined: <WalletOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />
};
